import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { UnifiedPerson } from 'CitizenProfile/types'
import CitizenCard from 'CitizenProfile/components/CitizenCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getUnifiedPersonOnCustomForm from './services/getUnifiedPersonOnCustomForm'

export default function CustomFormAnswerUnifiedPerson() {
  const [loadingUnifiedPerson, setLoadingUnifiedPerson] = useState<boolean>(false)
  const [unifiedPerson, setUnifiedPerson] = useState<UnifiedPerson>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const unifiedPersonId: string = answerValue

  async function getUnifiedPerson() {
    setLoadingUnifiedPerson(true)
    const response = await getUnifiedPersonOnCustomForm({ unifiedPersonId })
    if (response?.header?.success) {
      const unifiedPersonFromAPI = response?.body?.unified_person
      setUnifiedPerson(unifiedPersonFromAPI)
    }
    setLoadingUnifiedPerson(false)
  }

  useEffect(() => {
    if (answerValue) getUnifiedPerson()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingUnifiedPerson}>
      <CitizenCard borderWidth="1px" borderColor="borderColor" citizen={unifiedPerson} isDefaultCitizenCard />
    </Skeleton>
  )
}
